import { IApplicationState } from '../../../../types/types';
import { getUserPromoCode } from './getUserPromoCode';

export const getUserPromoCodeDiscount = (
    state: IApplicationState
): number => {
    const promoCode = getUserPromoCode(state);
    return promoCode && promoCode.discount
};
